<template>
        <Email :to="to" :value="emailValue" @input="emitEmail($event)"></Email>
</template>

<script>
  import responseMixin from "./responseMixin";
  import Email from "./components/Email";
  export default {
    name: "IpsativeResponse",
    mixins: [responseMixin],
    components:{
            Email
    },
    computed: {
      to(){
         return this.questionresponse.email_to.split(';').map((v)=>v.trim());
      },
      responseitems(){
        return (this.responseoptions || []).map((opt)=>{
          return {
                  id:opt.optionid,
                  text:this.$ta(opt.content_textassetid),
          };
        });
      },
      fields(){
        return this.journeyanswers.map((ans)=>{
            return {
                fieldid:ans.journeyanswerid,
                text:this.$ta(ans.field.content_textassetid),
            }
        });
      },
      emailValue(){
          if(!this.value){
              return {
                  subject:null,
                  body:null,
              }
          }
          return {
             subject:this.value.answers[this.journeyanswers[0].journeyanswerid].value,
             body:this.value.answers[this.journeyanswers[1].journeyanswerid].value,
          };
      }
    },
    methods:{
     emitEmail(email){
       const result=JSON.parse(JSON.stringify(this.value));
       result.answers[this.fields[0].fieldid].value=email.subject;
       result.answers[this.fields[1].fieldid].value=email.body;
       this.emitInput(result);
     }
    }
  }
</script>

<style scoped>

</style>